import { Heart } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const Footer = () => {
  const { t, language } = useLanguage();

  return (
    <footer className="py-12 bg-white border-t border-[#E5E5E5]" data-testid="footer">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <p className="font-serif text-2xl text-[#2D2A26] mb-2">
          Adrienne & Thomas
        </p>
        <a
          href="mailto:contact@adriennethomaslove.com"
          className="text-[#999] text-sm hover:text-[#B5985A] transition-colors mb-4 block"
        >
          contact@adriennethomaslove.com
        </a>
        <p className="text-[#666] text-sm mb-4">
          {language === 'en' ? (
            <>September 5<sup className="text-[0.65em]">th</sup>, 2026 • Château des Joncherets</>
          ) : (
            t('footerDate')
          )}
        </p>
        <div className="flex items-center justify-center gap-1 text-[#999] text-xs">
          <span>{t('madeWith')}</span>
          <Heart className="w-3 h-3 fill-[#B5985A] text-[#B5985A]" />
        </div>
      </div>
    </footer>
  );
};
